import React from 'react';

import '../App.css';
import download from '../img/download-on-appstore.svg'
import logo from '../img/logo.png'
import feat from '../img/bb-feat.png'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useEffect } from 'react';
import { getAppInsights } from '../AppInsights';

const Main = () => {

  const appInsights = getAppInsights();
  useEffect(() => 
  {
    appInsights?.trackPageView({name: "Main"});
    
  }, []);

  const trackNavToStore = () => {
    appInsights?.trackEvent({ name: "NavigateToStore" });
  }

  const trackNavToFeatures = () => {
    appInsights?.trackEvent({ name: "NavigateToFeatures" });
  }

  return (
    <>
      <p>
        <img src={logo} alt='Beta Builder Logo' width={250} height={250} /> <br />
      </p>

        <h2>
            Chalk.
            Sweat.
            Send.</h2>
        <p><b>For climbers who chase.</b> Every hold, every move, every breakthrough. Beta Builder is your partner in the grind—built for those who show up, dust off, and push harder than yesterday.</p>
        <p><b>Projects aren't sent in a day.</b> They're built on falls, failed attempts, and coming back for more. Track every burn, learn from every slip, and watch the breakthrough happen. No fluff. Just progress.</p>
        <p><b>See the work.</b> Visualize every session, every attempt, every step forward. The data doesn't lie—it shows you where you're strong and where to dig deeper.</p>
        <p><b>Dust off and get after it.</b> This is your tool for the work that counts.</p>

      <img src={feat} alt="Beta Builder Progress Screen" height={296} width={300}/>
      <p>
        <a href="https://apps.apple.com/us/app/beta-builder/id6740149361" onClick={trackNavToStore}><img src={download} alt='Download on AppStore' /></a>
      </p>
      <h3>Features</h3>
      <h4><a href="https://www.wishkit.io/slug/betabuilder" onClick={trackNavToFeatures}>Feature Roadmap</a></h4>
      <ul>
          <li><b>Custom Grades</b> – Your gym, your crag, your system. Track it how you climb it.</li>
          <li><b>Progress Visuals</b> – See the work pay off. Charts that show where you're crushing it and where to push harder.</li>
          <li><b>Workout Timer</b> – Precise intervals. Max effort. Proper rest. Train like you mean it.</li>
          <li><b>Session Tracking</b> – Every attempt matters. Log the burns, find the patterns, send smarter.</li>
          <li><b>Projecting</b> – Document each attempt. Learn your beta. Crush your climb. Share it with friends.</li>
      </ul>
      <hr />
      <div><a href='/#privacy'>Privacy policy</a></div>
    </>
  );
}

export default Main;
